
<template>
    <span>{{ translation }}</span>
</template>

<script>
    import translateService from '../Services/TranslateService';

    export default {
        props: {
            'item': String,
            'fallback': String
        },

        data: function () {
            return {
                translations: translateService.TranslationsDictionary
            };
        },

        computed: {
            translation: function () {
                return this.translations["Vue." + this.item] || this.fallback || '[' + this.item + ']'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Vue/Src/Components/translate.vue